import { useEffect } from "react";
import { toast } from "sonner";

const BLOCKED_KEYS = [
  { key: "F12" },
  { key: "I", ctrl: true, shift: true },
  { key: "J", ctrl: true, shift: true },
  { key: "C", ctrl: true, shift: true },
  { key: "U", ctrl: true },
  { key: "S", ctrl: true },
];

const NOTICE = "© UnCloned® Media — this library is proprietary. Copying is not permitted.";

let lastToastAt = 0;
const notify = () => {
  const now = Date.now();
  if (now - lastToastAt < 2000) return;
  lastToastAt = now;
  toast(NOTICE, { duration: 2500 });
};

export const useContentProtect = () => {
  useEffect(() => {
    const onContext = (e) => { e.preventDefault(); notify(); };
    const onKey = (e) => {
      const match = BLOCKED_KEYS.some((k) =>
        e.key === k.key &&
        (!k.ctrl || e.ctrlKey || e.metaKey) &&
        (!k.shift || e.shiftKey)
      );
      if (match) { e.preventDefault(); notify(); }
    };
    const onDragStart = (e) => {
      if (e.target?.tagName === "IMG") { e.preventDefault(); notify(); }
    };
    document.addEventListener("contextmenu", onContext);
    document.addEventListener("keydown", onKey);
    document.addEventListener("dragstart", onDragStart);
    return () => {
      document.removeEventListener("contextmenu", onContext);
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("dragstart", onDragStart);
    };
  }, []);
};
